const fetchProductQuantitySelectorMockup = async (productHandle, inputSelector) => {
  let selector = inputSelector || '.js-price-quantity.js-rebuy-select';

  const response = await fetch(`/products/${productHandle}?view=product-detail`);
  const productDetailHtml = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(productDetailHtml, 'text/html').cloneNode(true);
  const selectMockUp = doc.querySelector(selector);
  if (!selectMockUp) {
    return undefined;
  }
  selectMockUp.classList.add('rebuy-js-rebuy-select');
  selectMockUp.classList.remove('js-price-quantity');
  selectMockUp.removeAttribute('name');
  return selectMockUp.cloneNode(true);
}

const addMaxAvailableQuantity = async (lineItemKey) => {
  const SmartCart = window.Rebuy.SmartCart;
  const lineItem = SmartCart.cart.items.find(item => item.key === lineItemKey);
  const productHandle = `${lineItem.handle}?variant=${lineItem.variant_id}`;

  const $quantity = await fetchProductQuantitySelectorMockup(productHandle, '.js-stock');
  if(!$quantity) return;
  const quantity = $quantity.innerHTML;
  
  const $rebuyModal = document.querySelector("#rebuy-modal");
  const $dialog = $rebuyModal.querySelector('.rebuy-notification-dialog-content');
  $dialog.innerHTML = `
    <p>Sorry, we only have <strong>${quantity}</strong> available for this product.</p>
  `;
}

const handleCartQuantityUpdate = (inputElement, newValue, prevValue, key) => {
  if (newValue % 1 !== 0) {
    inputElement.value = prevValue;
    return;
  }
  const Cart = window.Rebuy.Cart;
  const item = Cart.cart.items.find(item => item.key === key);

  let callbackTriggered = false;

  const fallbackTimeout = setTimeout(() => {
    if (!callbackTriggered) {
      console.warn('Callback not triggered. Reverting to previous value.');
      inputElement.value = prevValue;
      addMaxAvailableQuantity(key);
    }
  }, 1000);

  Cart.setItemQuantity(item, newValue, () => {
    callbackTriggered = true;
    clearTimeout(fallbackTimeout);
  });
}

const enrichProductLine = (smartcart) => {
  const rebuyCart = document.querySelector("#rebuy-cart");

  for (let i = 0; i < smartcart.cart.items.length; i++) {
    const lineItem = smartcart.cart.items[i];
    const finalLinePrice = lineItem.final_line_price;
    const $productListItem = rebuyCart.querySelector(`[data-key="${lineItem.key}"]`);

    if (!$productListItem) {
      continue;
    }

    const $productTotalPrice = $productListItem.querySelector('.rebuy-cart__flyout-item-total-price');
    if ($productTotalPrice) {
      $productTotalPrice.remove();
    }

    const $productInfoCart = $productListItem.querySelector('.rebuy-cart__flyout-item-info');
    const $container = document.createElement('div');
    $container.classList.add('rebuy-cart__flyout-item-total-price');
    $container.innerHTML = `
      <div>
        <span class="sr-only">Total Price</span>
        <span>Ext. Price</span>
      </div>
      <div>
        <span class="rebuy-money">
          <span class="sr-only">Price</span>
          <span>$${(finalLinePrice / 100).toFixed(2)}</span>
        </span>
      </div>
    `;
    $productInfoCart.appendChild($container);
  }
}

const addTitleMockup = (smartcart) => {
  const rebuyCart = document.querySelector("#rebuy-cart");

  for (let i = 0; i < smartcart.cart.items.length; i++) {
    const lineItem = smartcart.cart.items[i];
    const $productListItem = rebuyCart.querySelector(`[data-key="${lineItem.key}"]`)

    if (!$productListItem) {
      continue;
    }

    const $quantityTitle = $productListItem.querySelector('.rebuy-cart__flyout-item-quantity-title');

    if ($quantityTitle) {
      continue
    }

    const $quantityContainer = $productListItem.querySelector('.rebuy-cart__flyout-item-quantity');
    const $container = document.createElement('div');
    $container.classList.add('rebuy-cart__flyout-item-quantity-title');
    $container.innerHTML = `
      <span class="sr-only">Quantity</span>
      <span>Quantity</span>
    `;
    $quantityContainer.prepend($container);


    const UnitPriceTitle = $productListItem.querySelector('.rebuy-cart__flyout-item-unit-price-title');

    if (UnitPriceTitle) {
      continue
    }

    const $unitPriceContainer = $productListItem.querySelector('.rebuy-cart__flyout-item-price');
    const $unitPriceTitleContainer = document.createElement('div');
    $unitPriceTitleContainer.classList.add('rebuy-cart__flyout-item-unit-price-title');
    $unitPriceTitleContainer.innerHTML = `
      <div>
        <span class="sr-only">Unit Price</span>
        <span>Unit Price</span>
      </div>
    `;
    $unitPriceContainer.prepend($unitPriceTitleContainer);
  }
}

const adjustQuantitySelector = ($selectMockUp, lineItem) => {
  const currentQuantity = lineItem.quantity;
  const $options = $selectMockUp.querySelectorAll('option');
  const options = Array.from($options).map(option => parseInt(option.value));
  const lowestValue = Math.min(...options);

  // Then do nothing here beside "select" the current quantity
  if (options.includes(currentQuantity)) {
    $selectMockUp.value = currentQuantity;
    $selectMockUp.querySelector(`option[value="${currentQuantity}"]`).selected = true;
    return false;
  }
  // We'll also need to adjust the line item with smart cart correct the quantity
  else if (currentQuantity < lowestValue) {
    $selectMockUp.querySelector(`option[value="${lowestValue}"]`).selected = true;
    handleCartQuantityUpdate($selectMockUp, lowestValue, lowestValue, lineItem.key);
    return true;
  }
  // If the current quantity is not in the options, we'll need to adjust to the lower value
  else {
    const adjustedValue = options.filter(option => option < currentQuantity).pop();
    $selectMockUp.querySelector(`option[value="${adjustedValue}"]`).selected = true;
    handleCartQuantityUpdate($selectMockUp, adjustedValue, lowestValue, lineItem.key);
    return true;
  }
}

const updateQuantitySelectorForReelProducts = async (smartcart) => {
  const rebuyCart = document.querySelector("#rebuy-cart");

  for (let i = 0; i < smartcart.cart.items.length; i++) {
    const lineItem = smartcart.cart.items[i];
    const $productListItem = rebuyCart.querySelector(`[data-key="${lineItem.key}"]`)

    if (!$productListItem) {
      continue;
    }

    const selectMockUp = await fetchProductQuantitySelectorMockup(lineItem.handle);
    if (!selectMockUp) {
      continue;
    }
    const $quantityWidget = $productListItem.querySelector('.rebuy-cart__flyout-item-quantity-widget');

    if ($quantityWidget) {
      // replace the quantity widget with the mockup
      $quantityWidget.outerHTML = selectMockUp.outerHTML;
      const quantityAdjusted = adjustQuantitySelector(selectMockUp, lineItem);
      if (quantityAdjusted) break;
    }

  }
}

const adjustSelectQuantitySelector = (smartcart) => {
  const rebuyCart = document.querySelector("#rebuy-cart");

  for (let i = 0; i < smartcart.cart.items.length; i++) {
    const lineItem = smartcart.cart.items[i];
    const $productListItem = rebuyCart.querySelector(`[data-key="${lineItem.key}"]`)

    if (!$productListItem) {
      continue;
    }

    const $selectWidget = $productListItem.querySelector('.js-rebuy-select.rebuy-js-rebuy-select');

    if ($selectWidget) {
      // replace the quantity widget with the mockup
      adjustQuantitySelector($selectWidget, lineItem);
    }
  }
}

const handleCartSelectionUpdate = (selectElement) => {
  const newValue = selectElement.value;
  const $options = selectElement.querySelectorAll('option');
  const options = Array.from($options).map(option => parseInt(option.value));
  const lowestValue = Math.min(...options);

  const handle = selectElement.getAttribute('data-handle');
  const $parent = selectElement.closest(`li.product-${handle}`);

  if (!$parent) {
    return;
  }
  const key = $parent.getAttribute('data-key');

  handleCartQuantityUpdate(selectElement, newValue, lowestValue, key);
}

const handleShowQuote = (smartcart) => {
  const numItems = smartcart.cart.items.length
  const rebuyCart = document.querySelector("#rebuy-cart");
  const $emailWrapper = rebuyCart.querySelector(".cck-email.eq-email-wrapper");

  if (numItems > 0) {
    $emailWrapper.style.display = "block";
  }
  else {
    $emailWrapper.style.display = "none";
  }
}

const handleCartActiveStatus = (smartcart) => {
  const emptyCart = document.querySelector("#cart-icon-empty");
  const activeCart = document.querySelector("#cart-icon-active");

  if (smartcart.cart.items.length > 0) {
    emptyCart.style.display = "none";
    activeCart.style.display = "block";
  }
  else {
    emptyCart.style.display = "block";
    activeCart.style.display = "none";
  }
}

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

async function handleSmartCartEvent(smartcart) {
  enrichProductLine(smartcart);
  addTitleMockup(smartcart);
  handleShowQuote(smartcart);
  await updateQuantitySelectorForReelProducts(smartcart);
  adjustSelectQuantitySelector(smartcart);
}

const debouncedHandleSmartCartEvent = debounce(handleSmartCartEvent, 300);

document.addEventListener('rebuy:smartcart.show', async (event) => {
  const smartcart = event.detail.smartcart;
  debouncedHandleSmartCartEvent(smartcart, 300);
});

document.addEventListener('rebuy:cart.change', async (event) => {
  const cart = event.detail.cart;
  debouncedHandleSmartCartEvent(cart, 300);
  handleCartActiveStatus(cart);
});

document.addEventListener('rebuy:cart.ready', (event) => { 
  const cart = event.detail.cart;
  handleCartActiveStatus(cart);
});

document.addEventListener('change', function(event) {
  if (event.target && event.target.classList.contains('js-rebuy-quantity-input')) {
    const inputValue = event.target.value;
    const prevValue = event.target.getAttribute('data-prev-value');
    const key = event.target.getAttribute('data-key');

    handleCartQuantityUpdate(event.target, inputValue, prevValue, key);
  } else if (event.target && event.target.classList.contains('js-rebuy-select') && event.target.classList.contains('rebuy-js-rebuy-select')) {
    const selectElement = event.target;
    handleCartSelectionUpdate(selectElement);
  }
});

window.rebuyCartCreateQuote = function() {
  const SmartCart = window.Rebuy.SmartCart;
  SmartCart.show();
  document.querySelector("#rebuy-cart .cck-email.eq-email-wrapper details")?.setAttribute('open','')
}


